module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/credits-rate-mobile-f24d058ae37b74fdcca9f17b6354397b.png";